module.exports = __webpack_public_path__ + "img/gdq_gbt896_1986.prt.0ea3d6d9.jpg";